// Module
var code = "<div data-bind=\"if: highchartsOptions\">\n    <div data-bind=\"highcharts: {options: highchartsOptions, chart: chart}\" class=\"chart\"></div>\n</div>";
// Exports
module.exports = code;